import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGitBranchOutline = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "icon / ionicons / outline / git-branch-outline",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.25 2.5C5.55964 2.5 5 3.05964 5 3.75C5 4.44036 5.55964 5 6.25 5C6.94036 5 7.5 4.44036 7.5 3.75C7.5 3.05964 6.94036 2.5 6.25 2.5ZM3.75 3.75C3.75 2.36929 4.86929 1.25 6.25 1.25C7.63071 1.25 8.75 2.36929 8.75 3.75C8.75 5.13071 7.63071 6.25 6.25 6.25C4.86929 6.25 3.75 5.13071 3.75 3.75Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.25 15C5.55964 15 5 15.5596 5 16.25C5 16.9404 5.55964 17.5 6.25 17.5C6.94036 17.5 7.5 16.9404 7.5 16.25C7.5 15.5596 6.94036 15 6.25 15ZM3.75 16.25C3.75 14.8693 4.86929 13.75 6.25 13.75C7.63071 13.75 8.75 14.8693 8.75 16.25C8.75 17.6307 7.63071 18.75 6.25 18.75C4.86929 18.75 3.75 17.6307 3.75 16.25Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)_3",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.25 5C6.59518 5 6.875 5.27982 6.875 5.625V14.375C6.875 14.7202 6.59518 15 6.25 15C5.90482 15 5.625 14.7202 5.625 14.375V5.625C5.625 5.27982 5.90482 5 6.25 5Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)_4",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.75 5C13.0596 5 12.5 5.55964 12.5 6.25C12.5 6.94036 13.0596 7.5 13.75 7.5C14.4404 7.5 15 6.94036 15 6.25C15 5.55964 14.4404 5 13.75 5ZM11.25 6.25C11.25 4.86929 12.3693 3.75 13.75 3.75C15.1307 3.75 16.25 4.86929 16.25 6.25C16.25 7.63071 15.1307 8.75 13.75 8.75C12.3693 8.75 11.25 7.63071 11.25 6.25Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector (Stroke)_5",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M13.75 7.5C14.0952 7.5 14.375 7.77982 14.375 8.125C14.375 9.568 13.815 10.5099 12.9298 11.1124C12.1074 11.6721 11.0446 11.9052 10.1275 12.0962C10.0777 12.1066 10.0282 12.1169 9.97927 12.1271C9.06466 12.317 8.29781 12.4763 7.73115 12.799C7.45047 12.9588 7.24646 13.1457 7.1087 13.3761C6.97148 13.6057 6.875 13.9201 6.875 14.375C6.875 14.7202 6.59518 15 6.25 15C5.90482 15 5.625 14.7202 5.625 14.375C5.625 13.7362 5.76289 13.1912 6.03583 12.7347C6.30823 12.2791 6.69016 11.9533 7.1126 11.7127C7.85947 11.2874 8.81634 11.0903 9.66292 10.9159C9.73362 10.9013 9.80355 10.8869 9.87253 10.8725C10.8304 10.6729 11.6426 10.4763 12.2265 10.079C12.7475 9.72446 13.125 9.182 13.125 8.125C13.125 7.77982 13.4048 7.5 13.75 7.5Z",
				fill: "white"
			})
		]
	})
});
export default SvgGitBranchOutline;
